const YthHeading = (() => {
    $('#heading_dt').DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        ordering: true,
        searching: true,
        pageLength: 25,
        ajax: {
            url: '/admin/headings/listing',
            type: 'POST'
        },
        columns: [
            { data: 'heading_name', name: 'heading_name' },
            { data: 'gcid_name', name: 'gcid_name' },
            { data: 'total_keywords', name: 'total_keywords', orderable: false },
            { data: 'status', name: 'status' },
            { data: 'xref_count', name: 'sub_headings_count', searchable:false },
            {
                data: 'action',
                name: 'action',
                orderable: true,
                searchable: true
            },
        ]
    });

    //delete headings keywords
    $(document).on('click', '.delete-heading', function (event) {
        const id = $(event.currentTarget).data('id');
        var option_id = $(this).data("id");
        Swal.fire({
            icon: 'error',
            title: 'Do you want to delete?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "POST",
                    data: { _method: 'delete' },
                    url: baseUrl + "/admin/headings/" + id,
                    success: function (data) {
                        var oTable = $('#heading_dt').dataTable();
                        oTable.fnDraw(false);
                        Swal.fire(data.message, '', 'success');
                    },
                    error: function (data) {
                        Swal.fire(data.responseJSON.message, '', 'error');
                    }
                });

            }
        });
    });

    $(document).on('click', '.add-sub-heading', function (event) {
        let xRefObj = $(this);
        if (xRefObj.attr('data-id') > 0) {
            $('#subHeadingModal').modal('show');
            $('#ypHeadings').attr('data-parent-heading-id', xRefObj.attr('data-id'));
            $('#parentId').val(xRefObj.attr('data-id'));
        }
    });

    $('#ypHeadings').select2({
        dropdownParent: $("#subHeadingModal"),
        multiple: true,
        width: '100%',
        ajax: {
            url: `${baseUrl}/admin/yp-headings`,
            _method: 'GET',
            dataType: 'json',
            data: function (params) {
                return {
                    // Query parameters will be ?search=[term]&page=[page]
                    search: params.term,
                    id: $('#ypHeadings').attr('data-parent-heading-id')
                };
            },
            processResults: function (result) {
                return {
                    results: $.map(result.data, function (item) {
                        return {
                            text: item.heading_name,
                            id: item.id
                        }
                    })
                };
            }
        },
    });

    $('#ypHeadings').select2({
        dropdownParent: $("#subHeadingModal"),
        multiple: true,
        width: '100%',
        ajax: {
            url: `${baseUrl}/admin/yp-headings`,
            _method: 'GET',
            dataType: 'json',
            data: function (params) {
                return {
                    // Query parameters will be ?search=[term]&page=[page]
                    search: params.term,
                    id: $('#ypHeadings').attr('data-parent-heading-id')
                };
            },
            processResults: function (result) {
                return {
                    results: $.map(result.data, function (item) {
                        return {
                            text: item.heading_name,
                            id: item.id
                        }
                    })
                };
            }
        },
    });

    $('#editHeadings').select2({
        multiple: true,
        width: '100%',
        ajax: {
            url: `${baseUrl}/admin/yp-headings`,
            _method: 'GET',
            dataType: 'json',
            data: function (params) {
                return {
                    // Query parameters will be ?search=[term]&page=[page]
                    search: params.term,
                    id: $('#editHeadingId').val()
                };
            },
            processResults: function (result) {
                return {
                    results: $.map(result.data, function (item) {
                        return {
                            text: item.heading_name,
                            id: item.id
                        }
                    })
                };
            }
        },
    });


});

export default YthHeading;
